import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_PermissionAccessLevel } from '@nu-art/permissions-shared';
export const dispatch_onPermissionAccessLevelChanged = new ThunderDispatcherV3('__onPermissionAccessLevelUpdated');
export class ModuleFE_PermissionAccessLevel_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_PermissionAccessLevel, dispatch_onPermissionAccessLevelChanged);
        this._v1 = {};
    }
}
export const ModuleFE_PermissionAccessLevel = new ModuleFE_PermissionAccessLevel_Class();
//# sourceMappingURL=ModuleFE_PermissionAccessLevel.js.map